import { SubentityStateModel } from 'app/projects/subentity/src/lib/models/subentity.state-model';

export class WidgetsStateModel extends SubentityStateModel {}
